/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetMiniReference,
    AssetMiniReferenceFromJSON,
    AssetMiniReferenceFromJSONTyped,
    AssetMiniReferenceToJSON,
    MediaFileBundleMiniReference,
    MediaFileBundleMiniReferenceFromJSON,
    MediaFileBundleMiniReferenceFromJSONTyped,
    MediaFileBundleMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubtitleClipboardEntryUpdate
 */
export interface SubtitleClipboardEntryUpdate {
    /**
     * 
     * @type {AssetMiniReference}
     * @memberof SubtitleClipboardEntryUpdate
     */
    subtitle: AssetMiniReference;
    /**
     * 
     * @type {MediaFileBundleMiniReference}
     * @memberof SubtitleClipboardEntryUpdate
     */
    bundle?: MediaFileBundleMiniReference;
}

export function SubtitleClipboardEntryUpdateFromJSON(json: any): SubtitleClipboardEntryUpdate {
    return SubtitleClipboardEntryUpdateFromJSONTyped(json, false);
}

export function SubtitleClipboardEntryUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubtitleClipboardEntryUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtitle': AssetMiniReferenceFromJSON(json['subtitle']),
        'bundle': !exists(json, 'bundle') ? undefined : MediaFileBundleMiniReferenceFromJSON(json['bundle']),
    };
}

export function SubtitleClipboardEntryUpdateToJSON(value?: SubtitleClipboardEntryUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtitle': AssetMiniReferenceToJSON(value.subtitle),
        'bundle': MediaFileBundleMiniReferenceToJSON(value.bundle),
    };
}


